import styled from 'styled-components'

import { ClinTheme } from '../../../../ClinTheme'

interface StyledAddressContainerProps {
  paddingRight?: boolean
  paddingLeft?: boolean
  borderRight?: boolean
}

export const StyledOrderDeliveryContainer = styled.div({
  backgroundColor: ClinTheme.colors.white,
  padding: ClinTheme.space[4]
})

export const StyledTrackingContainer = styled.div({
  display: 'flex',
  marginBottom: ClinTheme.space[4]
})

export const StyledAddressContainer = styled.div({
  display: 'flex'
})

export const StyledOrderDeliveryItem = styled.div<StyledAddressContainerProps>(
  ({ paddingRight, paddingLeft, borderRight }) => ({
    flex: 1,
    paddingRight: paddingRight ? ClinTheme.space[4] : '0',
    paddingLeft: paddingLeft ? ClinTheme.space[4] : '0',
    borderRight: borderRight ? `1px solid ${ClinTheme.colors.midGrey}` : 'none'
  })
)

export const StyledNotAvailable = styled.span({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '120px',
  height: ClinTheme.space[4],
  borderRadius: ClinTheme.radii[3],
  background: ClinTheme.colors.lightBeige,
  fontSize: 12,
  fontWeight: 500
})
